import { dashboard } from './dashboard';
import { utilities } from './utilities';
import { other } from './other';

//-----------------------|| MENU ITEMS ||-----------------------//

const menuItems = {
    items: [utilities, dashboard, other]
};

// Filtra recursivamente os nós do menu com base no `account_type` do
// tenant - um nó sem `requiresAccountType` é sempre visível. Permite
// esconder grupos de módulo inteiros (ex: Linha de Produção só pra
// contas 'industria') sem precisar de nenhum framework de feature flag.
function filterByAccountType(items, accountType) {
    return items
        .filter((item) => !item.requiresAccountType || item.requiresAccountType.includes(accountType))
        .map((item) => (item.children ? { ...item, children: filterByAccountType(item.children, accountType) } : item));
}

export function getMenuItems(accountType) {
    return { items: filterByAccountType(menuItems.items, accountType) };
}

export default menuItems;
